import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { makeOutfitParser, category, replaceValue } from '../../outfit-parser';

var presetsList = ['primary', 'secondary', 'paragraph', 'tooltip'];
var colorsList = ['blue', 'gray', 'yellow', 'white', 'inherit'];
var modifiersList = ['underlined', 'semi-transparent'];
var arrowsList = ['arrow-up', 'arrow-down', 'arrow-right'];

export var anchorOutfits = [].concat(presetsList, colorsList, modifiersList, arrowsList);

var parsePreset = makeOutfitParser(category('presets', presetsList));

var parseOutfit = makeOutfitParser(category('colors', colorsList), category('modifiers', modifiersList, true), category('arrows', arrowsList));

var presets = {
  light: {
    primary: 'blue',
    secondary: 'gray',
    paragraph: 'blue underlined',
    tooltip: 'white underlined semi-transparent'
  },
  dark: {
    primary: 'yellow',
    secondary: 'gray',
    paragraph: 'yellow',
    tooltip: 'white underlined semi-transparent'
  }
};

export var parseAnchorOutfit = function parseAnchorOutfit(outfit, theme) {
  var _parsePreset$get = parsePreset(outfit).get('presets'),
      _parsePreset$get2 = _slicedToArray(_parsePreset$get, 1),
      preset = _parsePreset$get2[0];

  var enhancedOutfit = preset ? replaceValue(outfit, preset, presets[theme][preset]) : outfit;

  return parseOutfit(enhancedOutfit);
};